import { on } from "@ngrx/store";

import { JobToolState } from "../../job-tool.reducer";

import { JobManuallyAddLocationActions } from "./job-manually-add-location.actions";
import { jobManuallyAddLocationInitialState } from "./job-manually-add-location.state";

export const jobManuallyAddLocationReducers = [
  on(JobManuallyAddLocationActions.streetNumberInputChanged, (state: JobToolState, { streetNumber }) => {
    return {
      ...state,
      manuallyAddLocationDialog: {
        ...state.manuallyAddLocationDialog,
        streetNumber,
      }
    }
  }),
  on(JobManuallyAddLocationActions.streetNameInputChanged, (state: JobToolState, { streetName }) => {
    return {
      ...state,
      manuallyAddLocationDialog: {
        ...state.manuallyAddLocationDialog,
        streetName,
      }
    }
  }),
  on(JobManuallyAddLocationActions.areaCodeInputChanged, (state: JobToolState, { areaCode }) => {
    return {
      ...state,
      manuallyAddLocationDialog: {
        ...state.manuallyAddLocationDialog,
        areaCode: areaCode.replaceAll(' ', ''),
      }
    }
  }),
  on(JobManuallyAddLocationActions.cityInputChanged, (state: JobToolState, { city }) => {
    return {
      ...state,
      manuallyAddLocationDialog: {
        ...state.manuallyAddLocationDialog,
        city,
      }
    }
  }),
  on(JobManuallyAddLocationActions.countrySelected, (state: JobToolState, { country }) => {

    let jurisdiction = state.manuallyAddLocationDialog.jurisdiction;

    if (country !== state.manuallyAddLocationDialog.country) {
      jurisdiction = '';
    };

    return {
      ...state,
      manuallyAddLocationDialog: {
        ...state.manuallyAddLocationDialog,
        country,
        jurisdiction,
      }
    }
  }),
  on(JobManuallyAddLocationActions.jurisdictionSelected, (state: JobToolState, { jurisdiction }) => {
    return {
      ...state,
      manuallyAddLocationDialog: {
        ...state.manuallyAddLocationDialog,
        jurisdiction,
      }
    }
  }),
  on(
    JobManuallyAddLocationActions.cancelButtonClicked,
    JobManuallyAddLocationActions.closeDialogButtonClicked,
    (state: JobToolState) => {
      return {
        ...state,
        ...jobManuallyAddLocationInitialState,
      }
    },
  ),
];
